@if (parentForm) {
  <section class="grid grid-cols-2 gap-x-20 gap-y-30" [formGroup]="parentForm">
    <p class="col-span-2 text-lg">Enter a few details to complete your request.</p>
    @if (advisorList) {
      <div class="flex flex-col col-span-2 xs:col-span-1">
        <label class="mb-20 font-bold" for="agent">Select the advisor <sup class="text-red">*</sup></label>
        <mat-select formControlName="agent" class="select" placeholder="Please select an Advisor">
          @for (agent of advisorList; track agent) {
            <mat-option [value]="agent">{{agent.firstName}} {{agent.lastName}}</mat-option>
          }
        </mat-select>
        @if (parentForm.controls.agent.errors && parentForm.controls.agent.touched) {
          <span class="flex flex-col mt-5 text-xs font-medium gap-y-5 text-red">
            @if (parentForm.controls.agent.hasError('required')) {
              <span>This field is required.</span>
            }
          </span>
        }
      </div>
    }
    <div class="flex flex-col col-span-2 xs:col-span-1">
      <label class="mb-20 font-bold" for="client">Enter the client's name <sup class="text-red">*</sup></label>
      <input type="text" class="input" formControlName="client" placeholder="Please enter client's full name" />
      @if (parentForm.controls.client.errors && parentForm.controls.client.touched) {
        <span class="flex flex-col mt-5 text-xs font-medium gap-y-5 text-red">
          @if (parentForm.controls.client.hasError('required')) {
            <span>This field is required.</span>
          }
        </span>
      }
    </div>
    @if (!isFullFinancialPlan) {
      <div class="flex flex-col col-span-2 xs:col-span-1">
        <label class="mb-20 font-bold" for="nextAppointmentDate">When is the next appointment? <sup class="text-red">*</sup></label>
        <div class="datepicker-input-container">
          <input [matDatepicker]="picker" class="datepicker-input" formControlName="nextAppointmentDate" (click)="picker.open()" readonly
            placeholder="mm/dd/yyyy"  [min]="minStartDate">
            <mat-icon class="datepicker-icon" svgIcon="calendar" matDatepickerToggleIcon></mat-icon>
            <mat-datepicker #picker color="accent"></mat-datepicker>
          </div>
          @if (parentForm.controls.nextAppointmentDate.errors && parentForm.controls.nextAppointmentDate.touched) {
            <span class="flex flex-col mt-5 text-xs font-medium gap-y-5 text-red">
              @if (parentForm.controls.nextAppointmentDate.hasError('required')) {
                <span>This field is required.</span>
              }
            </span>
          }
        </div>
      }
      <div class="flex flex-col col-span-2">
        <label class="mb-20 font-bold" for="notes">Tell us what you would like to see</label>
        <textarea formControlName="notes" rows="6" class="textarea" placeholder="Enter your notes here"></textarea>
      </div>
    </section>
  }